module.exports = __webpack_public_path__ + "img/1.233b361f.jpg";